import { render, staticRenderFns } from "./profiles-input.vue?vue&type=template&id=7ed05324&"
import script from "./profiles-input.vue?vue&type=script&lang=ts&"
export * from "./profiles-input.vue?vue&type=script&lang=ts&"
import style0 from "./profiles-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed05324')) {
      api.createRecord('7ed05324', component.options)
    } else {
      api.reload('7ed05324', component.options)
    }
    module.hot.accept("./profiles-input.vue?vue&type=template&id=7ed05324&", function () {
      api.rerender('7ed05324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/profiles-input.vue"
export default component.exports